/* eslint-disable react-hooks/rules-of-hooks */
import { Box, ImageList, useMediaQuery } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import Loading from 'commons/Loading';
import PaginationCustom from 'commons/PaginationCustom';
import Text from 'commons/Text';
import { BREAKPOINTS } from 'configs/Constant';
import usePagination from 'hooks/usePagination';
import useGalleryArtworks from 'pages/Gallery/hooks/useGalleryArtworks';
import useStatusCanRequestCertificate from 'react-query/hooks/queries/useStatusCanRequestCertificate';
import { useQueryParameters } from 'utils/utils';

import GalleryArtworkItem from '../GalleryArtworkItem';
import TabArtworkHeader from '../TabArtworkHeader';
import useStyles from './styles';

const GalleryArtwork = ({ isOwner, isPublicShare = false }) => {
  const { id, uuid } = useParams();
  const classes = useStyles();
  const { t } = useTranslation();
  const query = useQueryParameters();
  const searchValue = query.get('search');

  let listArtwork = [];
  let status = undefined;
  let page = 1;
  let totalPage = 1;
  let onPageChange = () => {};
  const isLaptop = useMediaQuery(BREAKPOINTS.laptop);
  const isMobile = useMediaQuery(BREAKPOINTS.mobile);

  const params = {};
  if (isPublicShare) {
    params.share_link_id = uuid;
  } else {
    params.user_uuid = id;
  }

  const { data: artworks, isPending } = useGalleryArtworks({
    ...params,
  });
  const { data: _status } = useStatusCanRequestCertificate();
  const {
    page: _page,
    totalPage: _totalPage,
    onPageChange: _onPageChange,
  } = usePagination(artworks?.count, artworks?.page_size);
  status = _status;
  page = _page;
  totalPage = _totalPage;
  onPageChange = _onPageChange;
  if (isPending) {
    return <Loading />;
  }
  listArtwork = artworks?.results;

  const getColumns = () => {
    if (isLaptop) {
      return 4;
    }
    if (isMobile) {
      return 1;
    }
    return 2; //tablet
  };

  return (
    <Box sx={{ mt: 3 }}>
      <TabArtworkHeader
        placeholder={t('search_by_artwork_name')}
        isOwner={isOwner}
      />

      <ImageList
        variant="masonry"
        cols={getColumns()}
        gap={40}
        sx={{ mt: 3 }}
      >
        <>
          {listArtwork?.map((artwork) => (
            <GalleryArtworkItem
              artwork={artwork}
              status={status}
              key={artwork?.id}
              isOwner={isOwner}
            />
          ))}
        </>
      </ImageList>

      {!isPublicShare && searchValue && listArtwork?.length === 0 && (
        <div className={classes.wrapTextNoResult}>
          <Text>{t('no_results_that_match_your_search')}</Text>
          <Text>{t('please_try_adjust_your_keywords')}</Text>
        </div>
      )}

      {!!totalPage && (
        <PaginationCustom
          paginationStyle={classes.pagination}
          count={totalPage}
          page={page}
          onChange={onPageChange}
        />
      )}
    </Box>
  );
};

export default GalleryArtwork;
